import _find from 'lodash/find';
import _forEach from 'lodash/forEach';
import templateCompiler from './template-compiler';

const lodash = { _find, _forEach };

const html = `
<div class="<%= classes.option %> is-radio <%= _find(values, 'image_url') ? 'is-system-color' : '' %>">
  <label class="<%= classes.label %>">
    <%= title %>
  </label>
  <div class="<%= classes.values %>">
    <% if (_find(values, 'image_url')) { %>
      <% _forEach(values, function (value){ %>
        <label class="<%= value.classes.all %> is-radio">
          <input class="<%= value.classes.state %>" type="radio" name="<%= handle %>" <%= value.state %>
          <%= value.controls %>
            >
            <span class="option-value-system-color <%= value.image_url ? 'with-image-color' : 'without-image-color' %>">
              <% if (value.image_url) { %>
                <img width="40px" src="<%= value.image_url %>" alt="<%= value.titleWithoutQuotes %>"
                  title="<%= value.titleWithoutQuotes %>">
                <% } else { %>
                  <%= value.title %>
                <% } %>
            </span>
        </label>
        <% }) %>
        <% } else { %>
          <% _forEach(values, function (value){ %>
            <label class="<%= value.classes.all %> is-radio">
              <input class="<%= value.classes.state %>" type="radio" name="<%= handle %>" <%= value.state %>
              <%= value.controls %>
                >
                <span>
                  <%= value.title %>
                </span>
            </label>
          <% }) %>
      <% } %>
  </div>
</div>`;

export default templateCompiler(html, lodash);
